<template>
  <div class="row">
    <div class="col-md-12">
      <DataTable
        ref="datatable"
        :width="'100%'"
        :settings="datatable.settings"
        :dataColumns="datatable.columns"
        :dataFeed="datatable.dataFeed"
        :dataHandle="datatable.handle"
        :dataTableHeight="datatable.height"
        :datas="datas"
        :defaultSortBy="datatable.sortBy"
        :defaultOrderBy="datatable.orderBy"
        :allowView="allowView"
        :allowEdit="allowEdit"
        :allowDelete="allowDelete"
        :hasContextMenu="hasContextMenu"
      >
      <template slot="menuButtons" slot-scope="props">
        <template v-if="props.item && props.item.data">
          <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
          <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
          <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
        </template>
      </template>
      </DataTable>
      <!-- END DATA TABLE -->
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Product Category',
        sectionName: 'product.category',
        sectionIcon: 'fas fa-glass',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.productCategory,
        navigation: [
          { name: 'Product', route: 'product.index' },
          { name: 'Product Category', route: 'product.category.index' },
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'Product List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.index' }) } },
            { name: 'Product Categories', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.category.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: 'product.category',
          webService: this.$root.WebService.productCategory,
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'name', title: 'Name', type: 'input', width: '50%', value: null },
          { key: 'short_name', title: 'Short Name', type: 'input', width: '30%', value: null },
          { key: 'created_at', title: 'Created At', type: 'datepicker', width: '20%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '50vh'
      },
      datas: [],
    }
  },
  created() {
    
  },
  mounted() {

    if( this.hasPermission('create product_category') ) this.pageSettings.buttons.push({ name: 'Add New Product Category', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData() {

    },
    importData() {

    },
    allowView(item) {
      return this.hasPermission('read product_category')
    },
    allowEdit(item) {
      return this.hasPermission('update product_category')
    },
    allowDelete(item) {
      return this.hasPermission('delete product_category')
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    }
  }
}
</script>